import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../../Common';
import Dialog from '../../Dialog';
import LoginHeader from '../../Login_header';
import Menu from '../../Menu';
import * as Picklist from '../../Picklist';

const Flm1_report = () => {

    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [onceRun, setOnceRun] = useState(false);
    const [userRight, setUserRight] = useState([]);
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState('');

    const [flmLocation, setFlmLocation] = useState(null);
    const [locationCode, setLocationCode] = useState(0);
    const [flmFilter, setFlmFilter] = useState("1");
    const [flmFilterText, setFlmFilterText] = useState("FLM1 Daily Summ and Bal.(FC)");
    const [flmViewType, setFlmViewType] = useState('V');
    const [flmDate, setFlmDate] = useState(new Date());
    const [locationTypeFlm, setLocationTypeFlm] = useState("O");
    const [fromDateFlm, setFromDateFlm] = useState(new Date());
    const [toDateFlm, setToDateFlm] = useState(new Date());
    const [interbranch, setInterbranch] = useState(true);
    const [filterCN, setFilterCN] = useState(true);
    const [filterTC, setFilterTC] = useState(true);
    const [filterVTM, setFilterVTM] = useState(true);
    const [filterEVTM, setFilterEVTM] = useState(true);
    const [filterDD, setFilterDD] = useState(true);
    const [filterTT, setFilterTT] = useState(true);
    const [reportTypeFlm, setReportTypeFlm] = useState("D");
    // const [selectedMonth, setSelectedMonth] = useState(new Date(startDate));
    const [startEndDate, setStartEndDate] = useState({ start: startDate, end: endDate });
    const [filterType, setFilterType] = useState("period");
    const [selectedMonth, setSelectedMonth] = useState(null);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setFlmLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'REPORTS_RBI_FLM'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    const handleChangeLocation = (value) => {
        setFlmLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        sessionStorage.activeBranch = loc[1];
    }
    const handleMonthChange = (date) => {
        setSelectedMonth(date);
        const start = new Date(date.getFullYear(), date.getMonth(), 1); // 1st of the month
        const end = new Date(date.getFullYear(), date.getMonth() + 1, 0); // last day of the month

        setStartEndDate({
            start: new Date(new Date(start).setDate(new Date(start).getDate() + 1)).toISOString().split("T")[0],
            end: new Date(new Date(end).setDate(new Date(end).getDate() + 1)).toISOString().split("T")[0]

        });
    };

    const handleGenerate = () => {
        console.log("fromDateFlm", fromDateFlm);
        console.log("toDateFlm", toDateFlm);
        $(".loader").show();
        var msg = [], i = 0;
        if (flmLocation === null) {
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if (((flmFilter !== '8'))
            && (Common.dateYMD(fromDateFlm) < startDate || Common.dateYMD(toDateFlm) > endDate || (flmFilter === '3' && filterCN === false && filterEVTM === false)
                || (flmFilter === '5' && filterCN === false && filterVTM === false))
        ) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = ((flmFilter === '3' && filterCN === false && filterEVTM === false) ? "Select atleast one product CN/EVTM" : '');
            msg[i++] = ((flmFilter === '5' && filterCN === false && filterVTM === false) ? "Select atleast one product CN/VTM" : '');
            msg[i++] = (Common.dateYMD(fromDateFlm) < startDate || Common.dateYMD(toDateFlm) > endDate ? "Date should be within financial year" : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                locationType: locationTypeFlm,
                location: locationCode,
                flmFilter: flmFilter,
                fromDate: ((flmFilter === '8A' && filterType === 'month') || flmFilter === '8') ? startEndDate.start : Common.dateYMD(fromDateFlm),
                fromDateDMY: Common.dateDMY(fromDateFlm),
                toDate: ((flmFilter === "8A" && filterType === "month") || flmFilter === "8") ? startEndDate.end : Common.dateYMD(toDateFlm),
                toDateDMY: Common.dateDMY(toDateFlm),
                date: Common.dateYMD(toDateFlm),
                type: flmViewType,
                filterInterbranch: interbranch,
                filterCN: filterCN,
                // filterTC: filterTC,
                filterVTM: filterVTM,
                filterEVTM: filterEVTM,
                filterDD: filterDD,
                filterTT: filterTT,
                reportTypeFlm: reportTypeFlm,
                selectedMonth: Common.dateYMD(selectedMonth)
            }
            if (flmFilter == "1") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm1", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "printflm1", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                }

            } else if (flmFilter == "2") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm2", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm2", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            } else if (flmFilter == "3") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm3", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm3", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                }
            }
            else if (flmFilter == "4") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm4", JSON.stringify(obj)], result => {
                        console.log("this is result ", result);
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm4", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            } else if (flmFilter == "5") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm5", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm5", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            } else if (flmFilter == "6") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm6", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm6", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });

                }
            } else if (flmFilter == "7") {
                if (flmViewType === 'D') {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, "Flm7", JSON.stringify(obj)], result => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                } else {
                    Common.callApi(Common.apiFlmReport, [sid, "Flm7", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                }
            } else if (flmFilter === "8") {
                Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, 'downloadFLM8', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (flmFilter === "NEW8") {
                Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, 'downloadNEWFLM8', JSON.stringify(obj)], (result) => {
                    $(".loader").hide();
                    setMsgText(Common.buildMessageFromArray([result]));
                    setMsgBox(true);
                });
            } else if (flmFilter === "8A") {
                if (flmViewType === 'V') {
                    Common.callApi(Common.apiFlmReport, [sid, "printflm8A", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                }
                else {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, 'printflm8A', JSON.stringify(obj)], (result) => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                }
            } else if (flmFilter === "flm8_6October") {
                if (flmViewType === 'V') {
                    Common.callApi(Common.apiFlmReport, [sid, "flm8_6October", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                } else {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, 'flm8_6October', JSON.stringify(obj)], (result) => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                }
            } else if (flmFilter === "purposeWiseReport") {
                if (flmViewType === 'V') {
                    Common.callApi(Common.apiFlmReport, [sid, "purposeWiseReport", JSON.stringify(obj)], result => {
                        var newWindow = window.open();
                        newWindow.document.write(result);
                        $(".loader").hide();
                    });
                } else {
                    Common.callDownloadApiPost1(Common.apiFlmReport, "post", [sid, 'purposeWiseReport', JSON.stringify(obj)], (result) => {
                        $(".loader").hide();
                        setMsgText(Common.buildMessageFromArray([result]));
                        setMsgBox(true);
                    });
                }
            }
        }
    }
    function locationTypeHandler(value) {
        setLocationTypeFlm(value);
        if (value === 'O') {
            setInterbranch(true);
        }
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>{flmFilterText}</h3>
                    </Col>
                </Row>
                <Row>&nbsp; </Row>
                <Row>
                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>Location Type <span className="text-danger">*</span></Form.Label>
                            <Form.Select value={locationTypeFlm} disabled={branchDisable === "true"} onChange={e => locationTypeHandler(e.target.value)}
                                required>
                                <option value="A">All</option>
                                <option value="O">One</option>
                            </Form.Select>
                        </Form.Group>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    {locationTypeFlm === 'O' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Location<span className="text-danger">*</span></Form.Label>
                                <AsyncSelect
                                    cacheOptions={false}
                                    defaultOptions={false}
                                    value={flmLocation}
                                    getOptionLabel={e => e.label + ' '}
                                    getOptionValue={e => e.id}
                                    loadOptions={Picklist.fetchLocationAllowedPicklist}
                                    onInputChange={Picklist.handleInputChange}
                                    onChange={handleChangeLocation}
                                    isDisabled={branchDisable === "true"}
                                >
                                </AsyncSelect>
                            </Form.Group>
                        </Col></> : null}

                    <Col className='col-md-3 col-6'>
                        <Form.Group>
                            <Form.Label>FLM Filter<span className="text-danger">*</span></Form.Label>
                            <Form.Select value={flmFilter}
                                onChange={(e) => {
                                    setFlmFilterText(e.target.options[e.target.selectedIndex].text);
                                    setFlmFilter(e.target.value);
                                }}
                                required>
                                <option value="1">FLM1 Daily Summ and Bal.(FC)</option>
                                <option value="2">FLM2 Daily Summ and Bal.(TC)</option>
                                <option value="3">FLM3 Purchase from Public(FC)</option>
                                <option value="4">FLM4 from FFMC/RMC-FC</option>
                                <option value="5">FLM5 Sale to Public (FC/TC)</option>
                                <option value="6">FLM6 Sale to FFMC/RMC (FC)</option>
                                <option value="7">FLM7 TC's Surrender to AD's</option>
                                {/* <option value="8A">FLM8 ADs Category-II</option> */}
                                {/* <option value="8">FLM8 Unified ADs Category-II</option>
                                <option value="NEW8">New RBI FLM8 Unified ADs Category-II</option>
                                <option value="flm8_6October">FLM8 Report 6 October Format</option> */}
                                <option value="flm8_6October">FLM8 Unified ADs Category-II</option>
                                <option value="purposeWiseReport">Purpose Wise Report</option>
                                {/* <option value="9">FLM9 TC's Purchase and Surrender</option>
                                <option value="10">FLM10 Sales(FC/TC) for B.Vst</option> */}
                            </Form.Select>
                        </Form.Group>
                    </Col>
                    {sessionStorage.getItem('userSrno') === '1' &&
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>FLM Filter<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={flmFilter}
                                    onChange={(e) => {
                                        setFlmFilterText(e.target.options[e.target.selectedIndex].text);
                                        setFlmFilter(e.target.value);
                                    }}
                                    required>
                                    <option value="1">FLM1 Daily Summ and Bal.(FC)</option>
                                    <option value="2">FLM2 Daily Summ and Bal.(TC)</option>
                                    <option value="3">FLM3 Purchase from Public(FC)</option>
                                    <option value="4">FLM4 from FFMC/RMC-FC</option>
                                    <option value="5">FLM5 Sale to Public (FC/TC)</option>
                                    <option value="6">FLM6 Sale to FFMC/RMC (FC)</option>
                                    <option value="7">FLM7 TC's Surrender to AD's</option>
                                    <option value="8A">FLM8 ADs Category-II</option>
                                    <option value="8">FLM8 Unified ADs Category-II</option>
                                    <option value="NEW8">New RBI FLM8 Unified ADs Category-II</option>
                                    <option value="flm8_6October">FLM8 Report 6 October Format</option>
                                    <option value="purposeWiseReport">Purpose Wise Report</option>
                                    {/* <option value="9">FLM9 TC's Purchase and Surrender</option>
                                <option value="10">FLM10 Sales(FC/TC) for B.Vst</option> */}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    }
                    { /* {(flmFilter === '8A') ?
                        <Col md={3}>
                            <Form.Group>
                                <Form.Label>Filter Type</Form.Label>
                                <div>
                                    <Form.Check
                                        inline
                                        type="radio"
                                        label="Period"
                                        name="filterType"
                                        value="period"
                                        checked={filterType === "period"}
                                        onChange={(e) => setFilterType(e.target.value)}
                                    />

                                    { <Form.Check
                                        inline
                                        type="radio"
                                        label="Month"
                                        name="filterType"
                                        value="month"
                                        checked={filterType === "month"}
                                        onChange={(e) => setFilterType(e.target.value)}
                                    /> }
                                </div>
                            </Form.Group>
                        </Col> : null} */}

                    {flmFilter === '3' || flmFilter === '5' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Report Type <span className="text-danger">*</span></Form.Label>
                                <Form.Select value={reportTypeFlm} onChange={e => setReportTypeFlm(e.target.value)}
                                    required>
                                    <option value="D">Detail</option>
                                    <option value="S">Summary</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </> : null}
                </Row>
                <Row>
                    {((flmFilter === "8A" && filterType === 'month') || flmFilter === "8" || flmFilter === "NEW8") && (
                        <>
                            <Col className="col-md-3 col-6 mt-2">
                                <Form.Group>
                                    <Form.Label>
                                        Select Month <span className="colorThemeRed">*</span>
                                    </Form.Label>

                                    <DatePicker
                                        selected={selectedMonth}
                                        onChange={handleMonthChange}
                                        dateFormat="MMMM"
                                        showMonthYearPicker
                                        placeholderText="Select Month"
                                        minDate={new Date(startDate)}
                                        maxDate={new Date(endDate)}
                                        className="form-control"
                                    />
                                </Form.Group>
                            </Col>
                        </>
                    )}
                    {
                        (flmFilter === "1" || flmFilter === '3' || flmFilter === '4' || flmFilter === "5" || flmFilter === '6' || flmFilter == "7" || flmFilter === "2" || (flmFilter === '8A' && filterType === 'period') || flmFilter === 'flm8_6October' || flmFilter === 'purposeWiseReport') ?
                            <>
                                {/* <Row><h4>Report Period</h4></Row> */}
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>From Date<span className="colorThemeRed">*</span></Form.Label><br />
                                        <DatePicker className="form-control"
                                            selected={fromDateFlm}
                                            onChange={(date) => setFromDateFlm(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                            </> : null
                    }
                    {
                        (flmFilter === "1" || flmFilter === '3' || flmFilter === '4' || flmFilter === "5" || flmFilter === '6' || flmFilter == "7" || flmFilter === "2" || (flmFilter === "8A" && filterType === "period") || flmFilter === 'flm8_6October' || flmFilter === 'purposeWiseReport') ?
                            <>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>To Date<span className="colorThemeRed">*</span></Form.Label><br />
                                        <DatePicker className="form-control"
                                            selected={toDateFlm}
                                            onChange={(date) => setToDateFlm(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            useShortMonthInDropdown
                                            dropdownMode="select"
                                            peekNextMonth
                                            customInput={
                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                            }
                                        />
                                    </Form.Group>
                                </Col>
                            </> : null}
                    {(flmFilter === "1" || flmFilter === "8" || flmFilter === "8A" || flmFilter === "NEW8" || flmFilter === "2") && locationTypeFlm === 'A' ? <>
                        <Row>
                            <Col>
                                <Form.Check
                                    size='sm'
                                    type="checkbox"
                                    label="Show inter branch "
                                    checked={interbranch}
                                    onChange={() => setInterbranch(!interbranch)}
                                />
                            </Col>
                        </Row>
                    </> : null}
                    {flmFilter === '3' || flmFilter === "5" ? <Row>
                        <Col className="col-md-1 col-1">
                            <Form.Check
                                size='sm'
                                type="checkbox"
                                label="CN"
                                checked={filterCN}
                                onChange={() => setFilterCN(!filterCN)}
                            />
                        </Col>
                        {flmFilter === '3' ? <>
                            <Col className="col-md-1 col-1">
                                <Form.Check
                                    size='sm'
                                    type="checkbox"
                                    label="EVTM"
                                    checked={filterEVTM}
                                    onChange={() => setFilterEVTM(!filterEVTM)}
                                />
                            </Col>
                            {/* <Col className="col-md-1 col-1">
                                    <Form.Check
                                        size='sm'
                                        type="checkbox"
                                        label="TC"
                                        checked={filterTC}
                                        onChange={() => setFilterTC(!filterTC)}
                                    />
                                </Col> */}
                        </>
                            :
                            <Col className="col-md-1 col-1">
                                <Form.Check
                                    size='sm'
                                    type="checkbox"
                                    label="VTM"
                                    checked={filterVTM}
                                    onChange={() => setFilterVTM(!filterVTM)}
                                />
                            </Col>
                        }
                        {flmFilter === "5" ?
                            <>
                                <Col className="col-md-1 col-1">
                                    <Form.Check
                                        size='sm'
                                        type="checkbox"
                                        label="DD"
                                        checked={filterDD}
                                        onChange={() => setFilterDD(!filterDD)}
                                    />
                                </Col>
                                <Col className="col-md-1 col-1">
                                    <Form.Check
                                        size='sm'
                                        type="checkbox"
                                        label="TT"
                                        checked={filterTT}
                                        onChange={() => setFilterTT(!filterTT)}
                                    />
                                </Col></> : null}
                    </Row> : null}

                    {flmFilter === '1' || flmFilter === '3' || flmFilter === '4' || flmFilter === '5' || flmFilter === '6' || flmFilter == "7" || flmFilter === '8A' || flmFilter === 'flm8_6October' || flmFilter === 'purposeWiseReport' ? <>
                        <Col className='col-md-3 col-6'>
                            <Form.Group>
                                <Form.Label>Mode<span className="text-danger">*</span></Form.Label>
                                <Form.Select value={flmViewType} onChange={e => setFlmViewType(e.target.value)}
                                    required>
                                    <option value="V">View</option>
                                    <option value="D">Download</option>
                                    {/* <option value="P">PDF</option> */}
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </> : null}
                </Row>
                <Row>&nbsp;</Row>
                <Row>
                    <Col>
                        <Button variant='outline-success' className='buttonStyle' size='sm' onClick={handleGenerate}>Generate</Button>
                    </Col>
                </Row>
            </Container>
            <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                {msgText}
            </Dialog>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
            <Row>&nbsp;</Row>
        </>
    )
}

export default Flm1_report;